import React from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno.js";
import ButtonPretsPro from "../buttons/button.pretpro.js";
import Simulateur84 from "../../views/simulateurs/simulateur.A1.12/simulateur.A1.12";
import Simulateur92 from "../../views/simulateurs/simulateur.A1.12PRO/simulateur.A1.12PRO";
import BadgeNouveau from "../texts/BadgeNouveau.js";
import CautionSansGarantieHypo from "./CautionSansGarantieHypo.js";

function Pret(props) {
  const handleChange = async (setter, value, key) => {
    if (setter) {
      setter(value);
    }

    if (props.handleChange) {
      props.handleChange(setter, value, key);
    }
  };

  const handleDependance84 = (obj) => {
    if (props.setSimu84) {
      props.setSimu84(obj);
    }
  };

  const handleDependance92 = (obj) => {
    if (props.setSimu92) {
      props.setSimu92(obj);
    }
  };
  const handleDependance114 = (obj) => {
    if (props.setSimu114) {
      props.setSimu114(obj);
    }
  };

  const pretHypo = props.pretHypo || 0;
  const pretsPro = props.pretsPro || 0;
  const cautionSansGarantieHypo = props.cautionSansGarantieHypo || 0;
  const isBlocked = parseInt(cautionSansGarantieHypo) === 1;

  return (
    <>
      <CautionSansGarantieHypo
        cautionSansGarantieHypo={cautionSansGarantieHypo}
        handleChange={handleChange}
        setCautionSansGarantieHypo={props.setCautionSansGarantieHypo}
        setSimu114={handleDependance114}
        simulateur={props.simulateur}
        departementId={props.departementId}
      />
      <div className="cardRow" style={isBlocked ? { opacity: 0.5, pointerEvents: "none" } : {}}>
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il un prêt hypothécaire ?
          {(props.simulateur.id === 115 || props.simulateur.id === 117) && (
            <BadgeNouveau cliquable={false}/>
          )}
        </div>
        <ButtonYesno
          handleChange={handleChange}
          setter={props.setPretHypo}
          fieldUndefined={false}
          defaultValue={pretHypo}
        />
      </div>

      {!isBlocked && parseInt(pretHypo) === 1 && props.withPretsProChoice && (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            S'agit-il d'un prêt aux particuliers ou d'un prêt aux professionnels ?
          </div>
          <ButtonPretsPro
            handleChange={handleChange}
            setter={props.setPretsPro}
            fieldUndefined={false}
            defaultValue={pretsPro}
          />
        </div>
      )}

      {!isBlocked &&
        parseInt(pretHypo) === 1 &&
        props.withPretsProChoice &&
        parseInt(pretsPro) === 0 && (
          <Simulateur84
            simulateur={props.simulateur}
            isParent={false}
            departementId={props.departementId}
            dependances={handleDependance84}
          />
        )}

      {!isBlocked &&
        parseInt(pretHypo) === 1 &&
        props.withPretsProChoice &&
        parseInt(pretsPro) === 1 && (
          <Simulateur92
            simulateur={props.simulateur}
            isParent={false}
            departementId={props.departementId}
            dependances={handleDependance92}
          />
        )}

      {!isBlocked && parseInt(pretHypo) === 1 && !props.withPretsProChoice && (
        <Simulateur92
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance92}
        />
      )}
    </>
  );
}

export default Pret;
